/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import axios from "axios";
import App from "App";
import JobLists from "components/Joblistings/JobLists";
import "index.css";

// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "context";
import { Provider } from "react-redux";
import store from "./Redux/store"
import formstore from "./app/formStore"
import SessionManager from "components/SessionManager";
import { setupInvalidSessionInterceptor } from "./services/sessionHandler";

setupInvalidSessionInterceptor(axios);

const container = document.getElementById("app");
const root = createRoot(container);
root.render(
  <BrowserRouter>
      <MaterialUIControllerProvider>
        <Provider store={store} >
          <SessionManager>
            <App />
          </SessionManager>
        </Provider>
      </MaterialUIControllerProvider>
    </BrowserRouter>
);
